import React, { Fragment } from 'react';
import { ContactGroupEntry } from './ContactGroupEntry';

export const ContactGroupEntries = ({ contactGroups, handleDelete, handleEdit }) => {
   
    const renderContactGroups = () => {
        const contactGroupsRendered = contactGroups.map(contactGroup => {
            return <ContactGroupEntry key={contactGroup.groupId} contactGroup={contactGroup} handleDelete={handleDelete} handleEdit={handleEdit}/>
        });
        
        return <Fragment>
                {contactGroupsRendered}
            </Fragment>;
    }

    return (
        <div>
            <table className="table table-striped table-bordered my-2">
                <thead className="thead-dark">
                    <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Description</th>
                        <th scope="col">Extension</th>
                        <th scope="col">Users</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {renderContactGroups()}
                </tbody>
            </table>           
        </div>
    )
}